import StyleObject from '../utils/styleobject'
import { Position, Dimension } from '@/interfaces/general'
import BaseAdapter from './base'
import DragAdapterInterface from '../interfaces/adapters'

export default class DragCopy extends BaseAdapter implements DragAdapterInterface {
  private el: HTMLElement
  private elDrag: HTMLElement
  private dimension: Dimension

  constructor(el: HTMLElement) {
    super()
    this.el = el
  }

  public onMouseDown(event: any): Position {
    event = this.getEvent(event)
    this.elDrag = this.el.cloneNode(true) as HTMLElement
    document.body.appendChild(this.elDrag)

    this.dimension = {
      width: this.elDrag.getBoundingClientRect().width,
      height: this.elDrag.getBoundingClientRect().height,
    }

    return this.getPosition(event)
  }

  public onMouseMove(event: any): Position {
    event = this.getEvent(event)
    const styleObject = new StyleObject(this.elDrag)
    const position = this.getPosition(event)

    styleObject.add('position', 'absolute')
    styleObject.add('pointer-events', 'none')
    styleObject.add('left', `${position.x}px`)
    styleObject.add('top', `${position.y}px`)

    this.el.setAttribute('style', 'opacity: .5')
    this.elDrag.setAttribute('style', styleObject.toString())

    return position
  }

  public onMouseUp(event: any): Position {
    event = this.getEvent(event)
    document.body.removeChild(this.elDrag)
    this.el.removeAttribute('style')

    return this.getPosition(event)
  }

  private getPosition(event: any): Position {
    if (!event) {
      return this.lastKnownPosition
    }

    let x = event.clientX
    let y = event.clientY

    x -= this.dimension.width * 0.5
    y -= this.dimension.height * 0.5

    this.lastKnownPosition = { x, y }
    return this.lastKnownPosition
  }
}
